import styled, { css, keyframes } from 'styled-components';

export type BigButtonProps = {
    bgColor: 'primary' | 'secondary' | 'tertiary' | 'blue';
    color: 'primary' | 'secondary' | 'secondary-alt' | 'white';
    allWidth?: boolean;
    cursorBlocked?: boolean;
    padding?: string;
    isLoading?: boolean;
};

export const BigButtonWrapper = styled.button<BigButtonProps>`
    font-family: 'Hero New';

    background-color: ${({ bgColor, theme }) => {
        if (bgColor === 'primary') return theme.colors['supernova-500'];
        else if (bgColor === 'secondary') return theme.colors['silver-300'];
        else if (bgColor === 'tertiary') return '#E4E4E7';
        else if (bgColor === 'blue') return '#008cff';
        return theme.colors['silver-300'];
    }};

    border: none;
    padding: ${({ padding }) => (padding ? padding : '0.75rem 1.25rem')};

    border-radius: 0.75rem;
    cursor: ${({ cursorBlocked }) =>
        cursorBlocked ? 'not-allowed' : 'pointer'};
    font-weight: 600;
    line-height: 1.5rem; /* 150% */
    font-size: 1rem;
    transition: transform 0.2s ease-in-out;

    width: ${({ allWidth }) => (allWidth ? '100%' : 'initial')};

    color: ${({ color, theme }) => {
        if (color === 'primary') return theme.colors['neutral-950'];
        else if (color === 'secondary') return theme.colors['neutral-500'];
        else if (color === 'white') return "#ffffff";
        else if (color === 'secondary-alt') return '#09090B';
    }};

    --scale-hover: 1.035;
    --scale-active: 0.96;

    ${props =>
        !props.cursorBlocked &&
        css`
            &:not(disabled) {
                &:hover {
                    transform: scale(var(--scale-hover));
                }

                &:active {
                    transform: scale(var(--scale-active));
                }
            }
        `}
`;

const rotate = keyframes`
  from {
    transform: rotate(360deg);
    
  }
  to {
    transform: rotate(0deg);
  }
`;

export const LoadingButtonWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;

    div {
        display: flex;
        justify-content: center;
        align-items: center;
        animation: ${rotate} 1.3s linear infinite;
    }
`;
